import { createSlotRecipe } from './runtime';

const toggleGroupConfig = {"name":"toggleGroup","slots":["root","item"],"defaultVariants":{"size":"md","variant":"outline"},"variantMap":{"size":["lg","md","sm"],"variant":["ghost","outline"]}}

export const toggleGroup = /* @__PURE__ */ createSlotRecipe(toggleGroupConfig)